import React, { Component } from 'react';
import PlayPause from './PlayPause';
import IcecastNowPlaying from './IcecastNowPlaying';

import sotherlyLogo from '../public/sotherly-logo.png';
import customchannels from '../public/customchannels.png';

class Player extends Component {

  constructor(props) {
    super(props);
    this.state = {
      track: {
        artist: 'Artist',
        title: 'Title',
        album: 'Album',
        album_art: { small: 'https://albumart.customchannels.rocks/default-album-art.png' }
      }
    };
  }

  componentDidMount() {
    const nowplaying = new IcecastNowPlaying(1446, 'http://stream.customchannels.net/sotherly_florida_96.mp3', 1);
    nowplaying.checkIcecast((data) => {
      this.setState({ track: data.data[0] });
    });
  }

  render() {
    return (
      <div className="Player">
          <img src={ this.state.track.album_art.small } alt="Album" className="album-art" />
          <h1>Now Playing</h1>
          <p className="channel-name">Sotherly Florida</p>
          <p className="artist">{ this.state.track.artist }</p>
          <p className="title">{ this.state.track.title }</p>
          <p className="album">{ this.state.track.album }</p>
          <PlayPause />
          <a href="http://sotherlyhotels.com/" target="_blank"><img src={ sotherlyLogo } className="sotherly-logo" alt="Sotherly Hotels" /></a>
          <a href="https://www.customchannels.net" target="_blank"><img src={ customchannels } className="customchannels-logo" alt="Custom Channels" /></a>
      </div>
    );
  }
}

export default Player;



// WEBPACK FOOTER //
// ./src/Player.js